

















import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

@Component({
    components: {
        'default-layout': DefaultLayout
    }
})
export default class TermsOfService extends Vue {
}
